export enum AI_DESCRIPTION_TYPE {
    TRACK = 'materialUpload:AIDescription',
    TRACK_ERROR = 'materialUpload:AIDescription:error'
}

export enum AI_QUIZ_GENERATE_TYPE {
    TRACK = 'aiQuizGenerateTrack',
    TRACK_MODAL = 'aiQuizModal',
    TRACK_ERROR = 'aiQuizGenerateTrack:error'
}

export enum AI_QUIZ_DOWNLOAD_TYPE {
    TRACK = 'aiQuizDownloadTrack',
    TRACK_ERROR = 'aiQuizDownloadTrack:error'
}

export enum AI_TOOLS_TYPE {
    TRACK = 'AiTools',
    TRACK_ERROR = 'AiTools:error'
}

export enum AI_EVENT {
    CLICK_TOOL = 'AI:clickTool',
    VIEW_ALL_DOCUMENTS = 'AI:viewAllDocuments',
    VIEW_ALL_CHATS = 'AI:viewAllChats',
    SWITCH_SOURCE = 'AI:switchSource',
    NAVIGATE_DOCUMENTS = 'AI:navigateDocuments',
    VIEW_DOCUMENT = 'AI:viewDocument',
    VIEW_CHAT = 'AI:viewChat',
    EDIT_DOCUMENT = 'AI:editDocument',
    DELETE_DOCUMENT = 'AI:deleteDocument',
    VIEW_CART_MENU = 'AI:viewCardMenu',
    EXIT_DOCUMENT = 'AI:exitDocument',
    SIDEBAR_CLICK = 'AI:sidebarClick',
    HIDE_NOTIFICATION = 'AI:hideNotification',
    TOGGLE_VERSION = 'AI:toggleVersion',
    EDIT_TITLE = 'AI:editTitle',
    REFINE_SUGGESTION = 'AI:refineSuggestion',
    REFINE_CUSTOM = 'AI:refineCustom',
    DOWNLOAD_ICON_AI_CHAT = 'AI:downloadIconAIChat',
    COPY_ICON_AI_CHAT = 'AI:copyIconAIChat',
    REFINE_CUSTOM_AI_CHAT = 'AI:refineCustomAIChat',
    CRETE_INTERACTIVE_AI_CHAT = 'AI:createInteractiveAIChat',
    REFINE_AI_CHAT = 'AI:refinementSuggestionsAIChat',
    RENAME_TITLE_AI_CHAT = 'AI:renameTitleAIChat',
    RENAME_TITLE_CHAT_DOCUMENT = 'AI:renameDocumentTitleInChat',
    CLICK_INFO_SETTINGS = 'AI:clickOnMoreInfoAISettings',
    EDIT_TEXT = 'AI:editText',
    COPY_TEXT = 'AI:copyText',
    MATERIAL_PAGE_SELECTOR = 'Ai:materialPageSelect',
    MATERIAL_PAGE_MODAL_SELECTOR = 'Ai:materialPageModalSelect',
    GLOBAL_FEEDBACK = 'AI:globalFeedback',
    GLOBAL_FEEDBACK_OPENED = 'AI:globalFeedbackOpened',
    GLOBAL_FEEDBACK_DISMISSED = 'AI:globalFeedbackDismissed',
    INLINE_FEEDBACK = 'AI:inlineFeedback',
    INLINE_FEEDBACK_OPENED = 'AI:inlineFeedbackOpened',
    INLINE_FEEDBACK_DISMISSED = 'AI:inlineFeedbackDismissed',
    INLINE_FEEDBACK_THUMB_UP = 'AI:inlineFeedbackThumbUp',
    INLINE_FEEDBACK_THUMB_DOWN = 'AI:inlineFeedbackThumbDown',
    INLINE_FEEDBACK_THUMB_WHY = 'AI:inlineFeedbackThumbDownWhy',
    CUSTOMISER_MODAL_CLOSED = 'AiTools:customiser:modalClosed',
    CUSTOMISER_CONFIG_SELECTED = 'AiTools:customiser:configSelected',
    CUSTOMISER_ADAPT_CLICKED = 'AiTools:customiser:adaptClicked',
    CUSTOMISER_BANNER_CTA_CLICKED = 'AiTools:customiser:bannerCtaClicked',
    CLICK_BETA_AI_OPT_IN_BANNER = 'AiTools:clickBetaAIOptInBanner',
    CUSTOMISER_VERSION_SWITCHED = 'AiTools:customiser:versionSwitched',
    EDIT_ICON_CLICKED = 'AiTools:editIconClicked',
    EDITOR_CLOSED = 'AiTools:editorClosed',
    PAGE_SWITCHED = 'AiTools:pageSwitched'
}
